import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { Driver } from '../core/driver';
import { SchdulerOrder } from '../core/scheduler-order';
import { SchedulerOrderService } from '../core/scheduler-order.service';

@Component({
  selector: 'app-schedule',
  templateUrl: 'schedule.component.html',
  styleUrls: ['schedule.component.css']
})
export class ScheduleComponent implements OnInit {
  @ViewChild('schedule') scheduleElement: ElementRef;
  @ViewChild('datePicker') datePickerElement: ElementRef;
  datePicker: any;

  constructor(
    private orderService: SchedulerOrderService
  ) {}

  ngOnInit() {
    this.initSchedule();
    this.initDatePicker();
    this.getDrivers();
    this.getOrders();
  }

  initSchedule() {
    let viewConfig = {
      name: 'timeline',
      render: 'tree',
      y_unit: scheduler.serverList('drivers'),
      y_property: 'driver_id',
      x_unit: 'hour',
      x_date: '%H:%i',
      x_step: 1,
      x_start: 0,
      x_size: 24,
      x_length: 24,
      section_autoheight: false,
      dy: 60,
      dx: 180,
      folder_dy: 20,
      event_dy: 55,
      event_min_dy: 55,
      resize_events: false,
      second_scale: {
          x_unit: 'day',
          x_date: '%d %F'
      }
    };
    Object.assign(scheduler.xy, {
      nav_height: -1
    });
    Object.assign(scheduler.config, {
      dblclick_create: false,
      drag_create: true,
      edit_on_create: false,
      time_step: 1
    });

    scheduler.createTimelineView(viewConfig);
    scheduler.init(this.scheduleElement.nativeElement, moment().startOf('day').toDate(), 'timeline');
    scheduler.attachEvent('onBeforeLightbox', () => false);
    scheduler.attachEvent('onViewChange', this.onScheduleViewChange.bind(this));

    scheduler.templates.timeline_scale_label = (key, label, section) => {
      let html;
      if (section.children && section.children.length) {
        html = `
          ${label}
        `;
      } else {
        html = `
          <div class="trip-text">
            ${label}
          </div>
          <div class="trip-buttons d-flex">
            <button type="button" class="btn" title="Zoom to route"><i class="fa fa-search-plus"></i></button>
            <button type="button" class="btn" title="Optimize"><i class="fa fa-bolt"></i></button>
            <button type="button" class="btn" title="Delete"><i class="fa fa-trash-o"></i></button>
            <button type="button" class="btn" title="Remove"><i class="fa fa-times"></i></button>
            <button type="button" class="btn" title="Save"><i class="fa fa-floppy-o"></i></button>
            <button type="button" class="btn" title="Revert Changes"><i class="fa fa-undo"></i></button>
          </div>
        `;
      }
      return html;
    };
  }

  initDatePicker() {
    let pickerElement = $(this.datePickerElement.nativeElement);
    let opts = {
      date: moment().startOf('day'),
      buttons: { showToday: true, showClose: true },
      format: 'YYYY-MM-DD'
    };

    pickerElement.datetimepicker(opts);
    pickerElement.on('change.datetimepicker', this.onDatePickerChange.bind(this));
    this.datePicker = pickerElement.data('datetimepicker');
  }

  toggleDatePicker() {
    this.datePicker.toggle();
  }

  onDatePickerChange(e) {
    let pickerDate = e.date.startOf('day');
    let scheduleDate = moment(scheduler.getState().date).startOf('day');
    if (pickerDate.isValid() && !pickerDate.isSame(scheduleDate)) {
      scheduler.setCurrentView(pickerDate.toDate());
    }
  }

  updateDatePicker(date) {
    let newDate = moment(date).startOf('day');
    if (newDate.isValid()) {
      this.datePicker.date(newDate);
    }
  }

  onScheduleViewChange(mode, date) {
    this.updateDatePicker(date);
  }

  prev() {
    scheduler._click.dhx_cal_prev_button();
  }

  next() {
    scheduler._click.dhx_cal_next_button();
  }

  private _drivers: Driver[];
  get drivers(): Driver[]{
      return this._drivers;
  }
  set drivers(_drivers: Driver[])
  {
      this._drivers = _drivers;
      scheduler.updateCollection('drivers', this._drivers);
  }

  private _orders: SchdulerOrder[];
  get orders(): SchdulerOrder[]{
      return this._orders;
  }
  set orders(_orders: SchdulerOrder[]){
      this._orders = _orders;
      scheduler.parse(this._orders, 'json');
  }

  getDrivers(): void {
    // this.driverService.getDrivers().then(drivers => this.drivers = drivers);
  }
  getOrders(): void {
    // this.orderService.getOrders().then(orders => this.orders = orders);
  }
}



// WEBPACK FOOTER //
// ./src/app/schedule/schedule.component.ts